<template>
  <div class="about-us">
    <div class="container">
      <h1 class="title">About Us</h1>
      <div class="content">
        <p>
          Welcome to <span class="brand">Tax Engine</span>, your trusted platform for seamless tax calculations across all U.S. states.
          Our mission is to simplify complex tax computations, specifically for tobacco products, ensuring accuracy and
          compliance with state-specific regulations.
        </p>
        <p>
          Whether you're a business or an individual, we provide an efficient and user-friendly experience to help you
          navigate varying tax rates and rules effortlessly. At <span class="brand">Tax Engine</span>, we prioritize
          innovation, security, and ease of use, making tax calculations straightforward and reliable.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>

<style scoped>
.about-us {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #252525;
  padding: 20px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 900px;
  background: white;
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0px 4px 10px rgba(5, 3, 3, 0.1);
  text-align: center;
}

.title {
  font-size: 2.2rem;
  color: #333;
  margin-bottom: 20px;
  font-weight: bold;
}

.content p {
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
  margin-bottom: 15px;
}

.brand {
  font-weight: bold;
  color: #007bff;
}

/* Responsive tweaks */
@media (max-width: 768px) {
  .container {
    padding: 30px 20px;
  }

  .title {
    font-size: 1.8rem;
  }

  .content p {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .title {
    font-size: 1.5rem;
  }

  .content p {
    font-size: 0.95rem;
  }
}
</style>
